var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trail-audio-slide py-4 py-md-0"},[_c('router-link',{staticClass:"text-light text-decoration-none",attrs:{"to":{
      name: 'audio',
      params: {
        id: _vm.resource.id
      }
    }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.img}}),_c('div',[_c('h6',[_vm._v(_vm._s(_vm.resource.name))]),_c('small',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.duration))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }